import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import templateMarkup from 'raw-loader!./summarydetail-widget.html';
import Signals from 'signals';
import UtilsService from '../../../services/utils.service';

var LONG_WAIT_TIME_THRESHOLD = 4000; // 4 seconds

function SummaryDetailWidget(params) {
    var self = this;

    self.params = params;
    self.observableOptions = params.observableOptions;
    self.observableData = params.observableData;
    self.panelTemplate = params.panelTemplate;

    self.parentWidgetSignals = params.widgetSignals;

    self.subscriptions = [];

    self.longLoadTimeoutId = null;

    self.getObsParams = function(optschanged) {
        if (!params.observableParamsList || !params.viewLevelOptions || _.isEmpty(params.viewLevelOptions())) {
            return null;
        }

        var obsparams = params.observableParamsList[0]();
        var paramsTemp = params.viewLevelOptions();
        var options = params.observableOptions();

        obsparams.queryId = "FlexAccessQueryWithMetadata";

        paramsTemp.pageNum = (optschanged === true) ? options.pageNum : 1;
        paramsTemp.pageSize = options.pageSize;
        paramsTemp.dataset = options.dataset;
        paramsTemp.aggregatefact = '';
        paramsTemp.groupby = '';
        paramsTemp.timegrain = '';
        paramsTemp.tag = '';
        paramsTemp.sortColumn = "";

        if (options.displayDetail && !_.isEmpty(options.displayDetail)) {
            paramsTemp.sortIndex = options.sortIndex ? options.sortIndex - 1 : 0;

            if (paramsTemp.sortIndex > (options.displayDetail.length - 1)) {
                paramsTemp.sortIndex = 0;
            }

            paramsTemp.sortColumn = options.displayDetail[paramsTemp.sortIndex];

            var sortOrder = (paramsTemp.sortColumn && options.sortAsc) ? " ASC" : " DESC";

            paramsTemp.sortColumn += sortOrder;
        }

        obsparams.paramsJson = ko.toJSON(paramsTemp);
        obsparams.url = $(location).attr("href");

        return obsparams;
    };

    self.setObsParams = function(optschanged) {
        var obsparams = self.getObsParams(optschanged);

        if (!obsparams) {
            return;
        }
        self.dispatchDataRequested();
        params.observableParamsList[0](obsparams);
    };

    self.subscriptions.push(params.viewLevelOptions.subscribe(self.setObsParams));

    if (_.isEmpty(ko.unwrap(self.observableData))) {
        self.dispatchDataRequested();
    }

    self.RefreshData();

    self.subscriptions.push(self.observableData.subscribe(function() {
        self.RefreshData();
    }));

    self.subscriptions.push(self.observableOptions.subscribe(function() {
        self.setObsParams(true);
    }));
}

SummaryDetailWidget.prototype.RefreshData = function() {
    var self = this;

    var options = self.observableOptions();
    var data = self.observableData();

    if (!_.isEmpty(data)) {
        if (!_.isEmpty(_.get(data, 'displayDetail')) && _.isEmpty(_.get(options, 'displayDetail'))) {
            options.displayDetail = $.extend([], data.displayDetail);
            options.displaySummary = $.extend([], data.displaySummary);

            if (data.colOptionsDetail && (!options.colOptionsDetail || (options.colOptionsDetail.length === 0))) {
                options.colOptionsSummary = data.colOptionsSummary;
                options.colOptionsDetail = data.colOptionsDetail;
            }
        }

        if (!_.isEmpty(_.get(data, 'colOptionsDetail')) && _.isEmpty(_.get(options, 'colOptionsDetail'))) {
            options.colOptionsSummary = data.colOptionsSummary;
            options.colOptionsDetail = data.colOptionsDetail;
        }
        self.dispatchDataLoaded();
    }
};

SummaryDetailWidget.prototype.dispatchDataRequested = function() {
    var self = this;
    dispatchSignal(self.parentWidgetSignals, 'dataRequested');

    if (_.isNil(self.longLoadTimeoutId)) {
        self.longLoadTimeoutId = setTimeout(_.bind(self.dispatchLongDataWait, self), LONG_WAIT_TIME_THRESHOLD);
    }
};

SummaryDetailWidget.prototype.dispatchDataLoaded = function() {
    var self = this;

    if (!_.isNil(self.longLoadTimeoutId)) {
        clearTimeout(self.longLoadTimeoutId);
        self.longLoadTimeoutId = null;
    }
    dispatchSignal(self.parentWidgetSignals, 'dataLoaded');
};

SummaryDetailWidget.prototype.dispatchLongDataWait = function() {
    var self = this;
    dispatchSignal(self.parentWidgetSignals, 'longDataWait');
};

// This runs when the component is torn down. Put here any logic necessary to clean up,
// for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
SummaryDetailWidget.prototype.dispose = function() {
    var self = this;
    self.subscriptions.forEach(function(sub) {
        sub.dispose();
    });

};

function dispatchSignal(signals, signalName) {
    UtilsService.dispatchSignal(_.get(signals, signalName));
}

export default {
    viewModel: SummaryDetailWidget,
    template: templateMarkup
};
